import { render, staticRenderFns } from "./miniTable.vue?vue&type=template&id=30441a01&scoped=true&"
import script from "./miniTable.vue?vue&type=script&lang=js&"
export * from "./miniTable.vue?vue&type=script&lang=js&"
import style0 from "./miniTable.vue?vue&type=style&index=0&id=30441a01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30441a01",
  null
  
)

component.options.__file = "miniTable.vue"
export default component.exports